export function defaultForNewEntity(object: any, key: string, defaultValue: any) {
  if (object) {
    return object[key];
  }

  return defaultValue;
}
